import StorageIcon from '@material-ui/icons/Storage';
import DatabaseItemCreate from './DatabaseItemCreate';
import DatabaseItemEdit from './DatabaseItemEdit';
import DatabaseItemList from './DatabaseItemList';
import DatabaseItemShow from './DatabaseItemShow';

const pages = {
    list: DatabaseItemList,
    create: DatabaseItemCreate,
    edit: DatabaseItemEdit,
    show: DatabaseItemShow,
    icon: StorageIcon,
};

export default pages;